import axios from "axios";

const axiosClient = axios.create({
  // baseURL: "http://localhost:8081/ppms_ws", // for devnp
  baseURL: "https://pumpmanagerbd.com:8443/ppms_ws", // for prod
  headers: {
    "Content-Type": "application/json",
  },
});

axiosClient.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");

  if (token) {
    config.headers.Authorization = token;
  } else {
    delete config.headers.Authorization;
  }

  return config;
});

export default axiosClient;
